import { render } from "./Shipments.vue?vue&type=template&id=3ebfe7a9&scoped=true&ts=true"
import script from "./Shipments.vue?vue&type=script&lang=ts"
export * from "./Shipments.vue?vue&type=script&lang=ts"

import "./Shipments.vue?vue&type=style&index=0&id=3ebfe7a9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ebfe7a9"]])

export default __exports__